import * as React from 'react';
import { Dropdown, Option, SelectionEvents } from "@fluentui/react-components";
import { useEditorStyles } from "../Styles/Editor";
import * as i18n from "i18next";
import { useTranslation } from "react-i18next";

type DocumentTypeDropdownProps = {
    setDocumentType: (dt: number) => void;
    currentDocumentType: number | null;
};
export function getDocumentTypeString(dt: number | null): string {
    if (dt === null) {
        return "";
    }
    switch (dt) {
        case 1:
            return i18n.t('1', { ns: 'DocumentType' });
        case 2:
            return i18n.t('2', { ns: 'DocumentType' });
        case 11:
            return i18n.t('101', { ns: 'DocumentType' });
        case 101:
            return i18n.t('101', { ns: 'DocumentType' });
        case 21:
            return i18n.t('201', { ns: 'DocumentType' });
        case 22:
            return i18n.t('202', { ns: 'DocumentType' });
        case 201:
            return i18n.t('201', { ns: 'DocumentType' });
        case 202:
            return i18n.t('202', { ns: 'DocumentType' });
        case 301:
            return i18n.t('301', { ns: 'DocumentType' });
        case 401:
            return i18n.t('401', { ns: 'DocumentType' });
        case 501:
            return i18n.t('501', { ns: 'DocumentType' });
        case 601:
            return i18n.t('601', { ns: 'DocumentType' });
        case 701:
            return i18n.t('701', { ns: 'DocumentType' });
        case 801:
            return i18n.t('801', { ns: 'DocumentType' });
    }
    return "?";
}

export const DocumentTypeDropdown: React.FC<DocumentTypeDropdownProps> = ({ setDocumentType, currentDocumentType }) => {
    const styles = useEditorStyles();
    const { t } = useTranslation();

    return <Dropdown
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        placeholder={t('SelectDocumentType')}
        className={styles.fluid}
        onOptionSelect={(event: SelectionEvents, data: { optionValue: string | undefined; }) => {
            setDocumentType(data.optionValue === undefined ? 21 : parseInt(data.optionValue));
        }}
        value={getDocumentTypeString(currentDocumentType)}
        selectedOptions={currentDocumentType ? [currentDocumentType.toString()] : []}
        aria-invalid={currentDocumentType === null}
    >
        <Option key="1" value="1">{i18n.t('1', { ns: 'DocumentType' })}</Option>
        <Option key="101" value="101">{i18n.t('101', { ns: 'DocumentType' })}</Option>
        <Option key="201" value="201">{i18n.t('201', { ns: 'DocumentType' })}</Option>
        <Option key="202" value="202">{i18n.t('202', { ns: 'DocumentType' })}</Option>
        <Option key="301" value="301">{i18n.t('301', { ns: 'DocumentType' })}</Option>
        <Option key="401" value="401">{i18n.t('401', { ns: 'DocumentType' })}</Option>
        <Option key="501" value="501">{i18n.t('501', { ns: 'DocumentType' })}</Option>
        <Option key="601" value="601">{i18n.t('601', { ns: 'DocumentType' })}</Option>
        <Option key="701" value="701">{i18n.t('701', { ns: 'DocumentType' })}</Option>
        <Option key="801" value="801">{i18n.t('801', { ns: 'DocumentType' })}</Option>
    </Dropdown>;
};

export const BasicDocumentTypeDropdown: React.FC<DocumentTypeDropdownProps> = ({ setDocumentType, currentDocumentType }) => {
    const styles = useEditorStyles();
    const { t } = useTranslation();

    return <Dropdown
        positioning="below"
        listbox={{
            className: styles.optionContainer,
        }}
        placeholder={t('SelectDocumentType')}
        className={styles.fluid}
        onOptionSelect={(event: SelectionEvents, data: { optionValue: string | undefined; }) => {
            setDocumentType(data.optionValue === undefined ? 21 : parseInt(data.optionValue));
        }}
        value={getDocumentTypeString(currentDocumentType)}
        selectedOptions={currentDocumentType ? [currentDocumentType.toString()] : []}
        aria-invalid={currentDocumentType === null}
    >
        <Option key="1" value="1">{i18n.t('1', { ns: 'DocumentType' })}</Option>
        <Option key="101" value="101">{i18n.t('101', { ns: 'DocumentType' })}</Option>
        <Option key="201" value="201">{i18n.t('201', { ns: 'DocumentType' })}</Option>
        <Option key="301" value="301">{i18n.t('301', { ns: 'DocumentType' })}</Option>
        <Option key="401" value="401">{i18n.t('401', { ns: 'DocumentType' })}</Option>
        <Option key="501" value="501">{i18n.t('501', { ns: 'DocumentType' })}</Option>
        <Option key="601" value="601">{i18n.t('601', { ns: 'DocumentType' })}</Option>
        <Option key="701" value="701">{i18n.t('701', { ns: 'DocumentType' })}</Option>
        <Option key="801" value="801">{i18n.t('801', { ns: 'DocumentType' })}</Option>
    </Dropdown>;
};